import React from "react";
import IEP from "../images/contenido/IEP.jpg";
import Capacitacion from "../images/contenido/Capacitacion.jpg";
import Libros from "../images/contenido/NiñosLibros.jpg";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

const C3Educacion = () => {
  return (
    <section id="educacion" className="nosotros bg-green-dark">
      <Fade delay={100} triggerOnce>
        <div className="block-circle"></div>
        <div className="container d-flex">
          <div className="images">
            <img src={IEP} alt="IEP" className="mohme-3" />
            <img src={Libros} alt="Estudiantes" className="mohme-1" />
            <img src={Capacitacion} alt="Docentes" className="mohme-2" />
          </div>
          <div className="text">
            <h3 className="section-title">3. Educación y Ciudadanía</h3>
            <div className="block-transparent"></div>
            <p>
              Es una iniciativa que favorece el desarrollo de competencias
              ciudadanas desde la escuela, transformando las prácticas de la
              enseñanza y el aprendizaje en las aulas con herramientas y
              recursos para estudiantes y profesores, así como para los padres,
              por medio de diversas actividades. De esta manera, responde a la
              demanda patente de construcción de ciudadanía en nuestro país y
              aporta a la formación de ciudadanos con agencia y valores que se
              proyectan en la comunidad.
            </p>
            <div>
              <div className="button-link">
                <Link to="/proyecto-democracia">
                  3.1 Proyecto Democracia: construyendo ciudadanía desde la
                  escuela
                </Link>
              </div>
              <div className="button-link">
                <Link to="/debate-educacion">
                  3.2 Debate sobre la educación como problema
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </section>
  );
};

export default C3Educacion;
